import { render, staticRenderFns } from "./ServiceCosts.vue?vue&type=template&id=314b5dc6&scoped=true&"
import script from "./ServiceCosts.vue?vue&type=script&lang=ts&"
export * from "./ServiceCosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314b5dc6",
  null
  
)

export default component.exports